module.exports = __webpack_public_path__ + "img/consultoria_4-3_2048.f682e76a.jpg";